import HorizontalNav from "./HorizontalNav";
import VerticalNav from "./VerticalNav";

const Nav = () => {
  return (
    <nav>
      <VerticalNav />
      <HorizontalNav />
    </nav>
  );
};

export default Nav;
